import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      tours: {},
    },
    mutations: {
      UPDATE_TOUR(state, { data, locale }) {
        state.tours = {
          ...state.tours,
          [locale]: {
            data: data,
            __updatedAt: Date.now()
          }
        }
      },
    },
    actions: {
      FETCH_TOUR({ state, commit }, { locale }) {
        if (state.tours[locale] 
          && Date.now() - state.tours[locale].__updatedAt < cachetime 
        ) return ;
        return axios.get(encodeURI(`/api/tour/top`))
          .then((res) => {
            const data = res.data || [];
            commit('UPDATE_TOUR', { data, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getTours: (state) => (locale) => {
        return state.tours[locale] ? state.tours[locale].data || [] : [];
      }
    }
  }
}